module.exports = __webpack_public_path__ + "media/recipes/126-85153f5a.png";